import axios from 'axios';
import { createCloudRunAxios } from './axios';

const remiApi = createCloudRunAxios('remi-api');

function rethrowWithDetail(err: unknown): never {
  if (axios.isAxiosError(err)) {
    const detail = err.response?.data?.detail;
    if (typeof detail === 'string') {
      throw new Error(detail);
    }
  }
  throw err;
}

/**
 * Tri-state per-channel consent change. Omitting a channel (or sending null)
 * leaves it unchanged; `global` applies to all three at once.
 */
export interface ContactConsentUpdate {
  voice?: boolean | null;
  sms?: boolean | null;
  email?: boolean | null;
  global?: boolean | null;
  reason?: string;
}

export interface ContactConsentUpdateResponse {
  success: boolean;
  contact_id: string;
  changed: Record<string, boolean>;
}

export const updateContactConsent = async (
  contactId: string,
  organizationId: string,
  update: ContactConsentUpdate
): Promise<ContactConsentUpdateResponse> => {
  try {
    const response = await remiApi.post(`/api/v1/contacts/${contactId}/consent`, update, {
      params: { organization_id: organizationId },
    });
    return response.data;
  } catch (err) {
    rethrowWithDetail(err);
  }
};
